/* eslint-disable no-alert */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import {
  Paper, FormControl, TextField, Button, Input, IconButton, InputAdornment, InputLabel,
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { TherapistValidationSchema } from '../utils/util';
import Drawer from './Drawer';
import Actions from '../actions';
import Loading from './Loading';

function AddTherapistForm(props) {
  const [state, setState] = useState({
    name: '',
    email: '',
    password: '',
    conPassword: '',
    photoUri: '',
    designation: '',
    show: false,
    showCon: false,
  });
  const [snack, setSnack] = useState({
    open: false,
    type: 'success',
    msg: '',
  });
  const [loading, setLoading] = useState(false);
  const closeSnack = () => { return setSnack({ ...snack, open: false }); };
  const handleChange = (e) => { return setState({ ...state, [e.target.name]: e.target.value }); };
  const resetState = () => {
    return setState({
      name: '',
      email: '',
      password: '',
      photoUri: '',
      designation: '',
      conPassword: '',
      show: false,
      showCon: false,
    });
  };
  const showPassword = () => { return setState({ ...state, show: !state.show }); };
  const showConPassword = () => { return setState({ ...state, showCon: !state.showCon }); };
  const formSubmitted = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await TherapistValidationSchema.validate(state);
      await props.addTherapist(state);
      setLoading(false);
      setSnack({ open: true, type: 'success', msg: 'Therapist created successfully' });
      resetState();
    } catch (err) {
      setLoading(false);
      setSnack({ open: true, type: 'error', msg: err.message });
      resetState();
    }
  };
  return (
    <Drawer>
      <Loading
        loading={loading}
        onClose={closeSnack}
        snack={snack}
      />
      <Paper style={{ width: '500px', padding: '50px', marginTop: 20 }}>
        <h3 style={{ marginTop: 0 }}>Add Therapist</h3>
        <form className="form" onSubmit={formSubmitted} autoComplete="off">
          <FormControl fullWidth style={{ marginTop: '15px' }}>
            <TextField
              id="name"
              name="name"
              label="Name"
              value={state.name}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl fullWidth style={{ marginTop: '15px' }}>
            <TextField
              id="photoUri"
              name="photoUri"
              label="photoUri"
              value={state.photoUri}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl fullWidth style={{ marginTop: '15px' }}>
            <TextField
              id="designation"
              name="designation"
              label="designation"
              value={state.designation}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl fullWidth style={{ marginTop: '15px' }}>
            <TextField
              id="email"
              name="email"
              label="Email"
              value={state.email}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl fullWidth style={{ marginTop: '15px' }}>
            <InputLabel htmlFor="standard-adornment-password">Password</InputLabel>
            <Input
              id="standard-adornment-password"
              type={state.show ? 'text' : 'password'}
              name="password"
              value={state.password}
              onChange={handleChange}
              endAdornment={(
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={showPassword}
                  >
                    {state.show ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
            )}
            />
          </FormControl>
          <FormControl fullWidth style={{ marginTop: '15px' }}>
            <InputLabel htmlFor="standard-adornment-password">Confirm Password</InputLabel>
            <Input
              id="standard-adornment-password"
              type={state.showCon ? 'text' : 'password'}
              name="conPassword"
              value={state.conPassword}
              onChange={handleChange}
              endAdornment={(
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={showConPassword}
                  >
                    {state.showCon ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
            )}
            />
          </FormControl>
          <FormControl fullWidth style={{ marginTop: '50px' }}>
            <Button variant="contained" type="submit" color="primary">Add Therapist</Button>
          </FormControl>
        </form>
      </Paper>
    </Drawer>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

export default withRouter(connect(null, mapDispatchToProps)(AddTherapistForm));
